export enum SystemAttributeOption {
  DateOfCreate = "dateofcreate",
  DateOfEdit = "dateofedit",
  Author = "author",
  LastEditor = "lasteditor",
  Area = "area",
  Length = "length",
  Coordinates = "coordinates",
  All = "all",
}
